import { observer } from "mobx-react-lite";
import { store } from "../../../../../stores/Store";
import { Button, CircularProgress } from "@mui/material";
import { Icons } from "../../../../../misc/Icons";


interface AutomationOptionsProps {
    hidden: boolean;
    automationOptions: any[];
    onSubmit: Function;
}


export default observer(function AutomationOptions ({
    hidden,
    automationOptions,
    onSubmit = (value) => {}
}: AutomationOptionsProps) {

    if (hidden) return <></>

    automationOptions.sort((a, b) => a.id?.localeCompare(b.id))
    var cos_forms = automationOptions.filter(option => option.id.startsWith("SMS"))
    var nat_forms = automationOptions.filter(option => option.id.startsWith("VAF_NAT"))
    var student_forms = automationOptions.filter(option => option.id.startsWith("VAF_STUDENT"))
    var skilledWorkerForms = automationOptions.filter(option => option.id.startsWith("VAF_SWV") || option.id.includes("VAF_GBM"))
    var dependantForms = automationOptions.filter(option => option.id.startsWith("VAF_DEP"))

    // Available form
    return (
        <div className="form">
            {automationOptions?.length === 1
                ? <p>We have found one relevant online form.</p>
                : <p>We have found {automationOptions.length} relevant online forms.</p>}

            <div style={{maxHeight: "70vh", overflowY: "auto", paddingRight: "10px"}}>
                {!!store.AutomationStore.runningAutomation ? (
                    <div style={{display: "flex", gap: "10px", justifyContent: "normal", alignItems: "center"}}>
                        <CircularProgress style={{width: "10px", height: "10px", margin: "0"}} />
                        {window.location.href.includes(store.AutomationStore.runningAutomation.parentUid) ? (
                            <small>Automation in progress</small>
                        ) : (
                            <small>Automation in progress: <span className="link" onClick={() => store.AppStore.navigate(store.AutomationStore.runningAutomation.parentUid)}>{store.AutomationStore.runningAutomation.automator?.label}</span></small>
                        )}
                    </div>
                ) : null}

                {nat_forms?.length ? (
                    <div>
                        <h4>Nationality Applications</h4>
                        {nat_forms.map((option, i) => <AutomationOption key={i} automationOption={option} handleClick={() => onSubmit(option)} />)}
                    </div>
                ) : null}

                {cos_forms?.length ? (
                    <div>
                        <h4>Sponsorship Certificate Applications (SMS)</h4>
                        {cos_forms.map((option, i) => <AutomationOption key={i} automationOption={option} handleClick={() => onSubmit(option)} />)}
                    </div>
                ) : null}

                {skilledWorkerForms?.length ? (
                    <div>
                        <h4>Skilled Worker Applications</h4>
                        {skilledWorkerForms.map((option, i) => <AutomationOption key={i} automationOption={option} handleClick={() => onSubmit(option)} />)}
                    </div>
                ) : null}

                {student_forms?.length ? (
                    <div>
                        <h4>Student Applications</h4>
                        {student_forms.map((option, i) => <AutomationOption key={i} automationOption={option} handleClick={() => onSubmit(option)} />)}
                    </div>
                ) : null}

                {dependantForms?.length ? (
                    <div>
                        <h4>Dependant Child & Partner Applications</h4>
                        {dependantForms.map((option, i) => <AutomationOption key={i} automationOption={option} handleClick={() => onSubmit(option)} />)}
                    </div>
                ) : null}
            </div>
        </div>
    )
})


function AutomationOption ({automationOption, handleClick}) {

    var automationInProgress = !!store.AutomationStore.runningAutomation

    return (
        <div style={{display: "flex", gap: "10px", alignItems: "center", margin: "10px 0"}}>
            <Icons.Automation style={{fontSize: "14px"}} color="primary" />

            <a href={automationOption.url} target="_blank" rel="noreferrer" className="link">{automationOption.label}</a>

            {automationOption.status === "maint" ? (
                <p style={{marginLeft: "auto"}}>Under maintenance</p>
            ) : null}

            <Button
                color="success"
                variant="contained"
                className="btn btn-sm"
                style={{marginLeft: "auto"}}
                disabled={automationInProgress || automationOption.status !== "enabled"}
                onClick={() => handleClick()}>
                Automate
            </Button>
        </div>
    )
}